<template>
	<PageWrapper>
		<div class="pt-8 pb-16 lg:pt-16 lg:pb-20 px-4">
			<h1 class="w-full text-center text-4xl sm:text-5xl font-semibold text-primary">
				{{ $t('eight-one-one.title') }}
			</h1>
		</div>

		<div class="max-w-3xl mx-auto px-6 pb-16 lg:pb-24 flex flex-col gap-6 text-lg text-default">
			<p>{{ $t('eight-one-one.intro') }}</p>

			<p>{{ $t('eight-one-one.how-to') }}</p>

			<p>
				{{ $t('eight-one-one.online-before') }}
				<a
					href="https://exactix.colorado811.org"
					target="_blank"
					rel="noopener noreferrer"
					class="text-primary underline underline-offset-2 hover:decoration-2"
				>exactix.colorado811.org</a>{{ $t('eight-one-one.online-after') }}
			</p>

			<h2 class="text-xl font-semibold text-highlighted pt-2">
				{{ $t('eight-one-one.important-heading') }}
			</h2>

			<div class="grid gap-6">
				<UPageFeature
					icon="i-lucide-calendar"
					:title="$t('eight-one-one.notice-title')"
					:description="$t('eight-one-one.notice-description')"
				/>
				<UPageFeature
					icon="i-lucide-clock"
					:title="$t('eight-one-one.expiry-title')"
					:description="$t('eight-one-one.expiry-description')"
				/>
			</div>

			<p>{{ $t('eight-one-one.closing') }}</p>

			<div class="flex justify-center pt-2">
				<UButton
					href="tel:811"
					:label="$t('eight-one-one.call-button')"
					icon="i-lucide-phone"
					size="xl"
					color="primary"
					variant="outline"
				/>
			</div>
		</div>
	</PageWrapper>
</template>

<script setup>
import {
	BASE_URL, COMPANY_NAME
} from '@/constants/index.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	useScope: 'global'
})

useHead({
	title: t('eight-one-one.meta-title'),
	meta: [
		{ name: 'url',
			content: `${BASE_URL}/811` },
		{ name: 'description',
			content: t('eight-one-one.meta-description', { COMPANY_NAME }) }
	]
})
</script>
